export enum CmsProductIseeRequirementEnum {
  yes = "yes",
  no = "no",
  optional = "optional",
}
